import PropTypes from "prop-types";
import React from "react";

import { Link } from "react-router-dom";

import ReactMarkdown from "react-markdown";

// @material-ui/core components
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { withStyles } from "@mui/styles";
import { Button, Card, CardBody, GridContainer, GridItem } from "~/shared/components/MuiComponents.jsx";

import Check from "@mui/icons-material/Check";

import consultationStyles from "../styles/consultationStyles.js";

import { COLOR_KICK_BLUE } from "~/shared/sharedConstants.js";

// consent markdown is in Buffalo views template directory
import telehealthConsent from "../../../../../templates/legal/telehealth-consent.plush.md";

// const store = createStore(VisitApp);
class Consents extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: [],
      consultationType: this.props.match.params.consultationType,
    };
  }

  handleToggle = (value) => {
    const { checked } = this.state;
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    this.setState({
      checked: newChecked,
    });
  };

  render() {
    const { classes } = this.props;
    return (
      <div
        className={classes.container}
        style={{ backgroundColor: COLOR_KICK_BLUE }}
      >
        <GridContainer justifyContent="center">
          <GridItem xs={12} sm={12} md={10}>
            <h2
              className={classes.cardTitle}
              style={{
                color: "white",
              }}
            >
              Informed Consent for Telehealth Services
            </h2>
            <h3
              className={classes.cardSubtitle}
              style={{
                color: "white",
                marginTop: "0",
              }}
            >
              Kick Health Medical Group, P.A.
            </h3>
            <p
              className={classes.cardSubtitle}
              style={{ color: "white", margin: "20px 20px 0 20px" }}
            >
              In order for us to treat you, please review the following
              agreement and check the box below to proceed.
            </p>

            <Card className={classes.cardConsultation}>
              <CardBody>
                <ReactMarkdown source={telehealthConsent} />

                <div className={classes.center} style={{ marginTop: "30px" }}>
                  <FormControlLabel
                    classes={{
                      root: classes.checkboxLabelControl,
                      label: classes.checkboxLabel,
                    }}
                    control={
                      <Checkbox
                        tabIndex={-1}
                        onClick={() => this.handleToggle(1)}
                        checkedIcon={<Check className={classes.checkedIcon} />}
                        icon={<Check className={classes.uncheckedIcon} />}
                        classes={{
                          checked: classes.checked,
                          root: classes.checkRoot,
                        }}
                      />
                    }
                    label={
                      <span>
                        I agree to the{" "}
                        <strong>
                          Informed Consent For Telehealth Services
                        </strong>
                      </span>
                    }
                  />
                </div>

                <div className={classes.center}>
                  <Link to={`/visits/${this.state.consultationType}/signup`}>
                    <Button
                      round
                      color="primary"
                      style={{ marginTop: "6px", width: "300px" }}
                    >
                      Start Visit
                    </Button>
                  </Link>
                </div>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

Consents.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(consultationStyles)(Consents);
